/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useState } from 'react';
import { MappingClientT, ObjectContainerClientT, ObjectTypeClientT, ObjectTypePropertyCollectionItemT, StatusClientT } from 'bovaljaren-models';
import './ObjectList.scss';
import ObjectListHeader from './ObjectListComponents/ObjectListHeader';
import ObjectListBody from './ObjectListComponents/ObjectListBody';
import { useObserver } from 'mobx-react-lite';
type Props={
    objects?: ObjectContainerClientT[];
    objectType: ObjectTypeClientT;
    onObjectListRowEnter?: (objectId: number) => void;
    onObjectListRowLeave?: (objectId: number) => void;
    onDataClick: (object: ObjectContainerClientT) => void;
    statuses?: StatusClientT[];
    objectMappings?: MappingClientT[];
}

export const rejectedObjectListProperties = [
    'richDescription',
    'description',
    'externalUrl'
];

export type ObjectSortingT = {sort: boolean; order: boolean; column?: ObjectTypePropertyCollectionItemT};


const ObjectList: React.FC<Props> = ({ objects, objectType, onObjectListRowEnter, onObjectListRowLeave, onDataClick, statuses, objectMappings }) => {

    const [sorting, setSorting] = useState<ObjectSortingT>({ sort: true, order: true, column: {
        id: 0,
        objectTypeId: objectType.id,
        sortOrder: 0,
        name: 'Name',
        type: 'name',
        baseType: 'string',
        ending: ''
    } });


    const filterdata = (type: ObjectTypePropertyCollectionItemT) => {
        const data = objects?.map(o => o.data).map(data => data.find(d => d.propId === type.id));

        return !!data?.find(d => d?.value !== undefined && d.value !== '' && d.value !== null) || false;
    };


    return (useObserver(() => <>{objects &&
        <table
            className={'bv-object-list-table'}
            cellSpacing={'1rem'}>
            <ObjectListHeader
                sorting={sorting}
                setSorting={setSorting}
                objectType={objectType}
                filterdata={filterdata}
            />
            <ObjectListBody
                sorting={sorting}
                objects={objects}
                objectType={objectType}
                onObjectListRowEnter={onObjectListRowEnter}
                onObjectListRowLeave={onObjectListRowLeave}
                onDataClick={onDataClick}
                statuses={statuses}
                filterdata={filterdata}
                objectMappings={objectMappings}/>
        </table>}</>)
    );
};
export default ObjectList;

